module.exports = __webpack_public_path__ + "media/images/abuse-survivors-c21dcbf329fe0062d5b875185a2d7c3d.png";